(function(){
  var root = document.getElementById('ring-size-calculator');
  if (!root) return;
  var sizes = [
    {au:"F",us:"3",mm:44.2,dia:14.07,eu:44},
    {au:"G",us:"3½",mm:45.5,dia:14.48,eu:45.5},
    {au:"H",us:"4",mm:46.8,dia:14.88,eu:47},
    {au:"I",us:"4½",mm:48.0,dia:15.29,eu:48},
    {au:"J",us:"5",mm:49.3,dia:15.70,eu:49},
    {au:"K",us:"5½",mm:50.6,dia:16.10,eu:50.5},
    {au:"L",us:"6",mm:51.9,dia:16.51,eu:52},
    {au:"M",us:"6½",mm:53.1,dia:16.92,eu:53},
    {au:"N",us:"7",mm:54.4,dia:17.32,eu:54.5},
    {au:"O",us:"7½",mm:55.7,dia:17.73,eu:56},
    {au:"P",us:"8",mm:57.0,dia:18.14,eu:57},
    {au:"Q",us:"8½",mm:58.3,dia:18.54,eu:58.5},
    {au:"R",us:"9",mm:59.5,dia:18.95,eu:60},
    {au:"S",us:"9½",mm:60.8,dia:19.35,eu:61},
    {au:"T",us:"10",mm:62.1,dia:19.76,eu:62},
    {au:"U",us:"10½",mm:63.4,dia:20.17,eu:63.5},
    {au:"V",us:"11",mm:64.6,dia:20.57,eu:65},
    {au:"W",us:"11½",mm:65.9,dia:20.98,eu:66},
    {au:"X",us:"12",mm:67.2,dia:21.39,eu:67.5},
    {au:"Y",us:"12½",mm:68.5,dia:21.79,eu:69},
    {au:"Z",us:"13",mm:69.7,dia:22.20,eu:70}
  ];
  var US_BASE = 36.25, US_STEP = 2.577;
  function mmToUs(mm){ return (mm-US_BASE)/US_STEP; }
  function usToMm(us){ return US_BASE+us*US_STEP; }
  function fmtUs(v){
    var q = Math.round(v*4)/4, w = Math.floor(q), f = q-w;
    if (f===0) return ''+w;
    if (f===0.25) return w+'¼';
    if (f===0.5) return w+'½';
    if (f===0.75) return w+'¾';
    return q.toString();
  }
  function closest(mm){
    var b = sizes[0], d = Math.abs(b.mm-mm);
    for (var i=1; i<sizes.length; i++){
      var dd = Math.abs(sizes[i].mm-mm);
      if (dd<d){ d=dd; b=sizes[i]; }
    }
    return b;
  }
  var $ = function(id){ return document.getElementById(id); };
  var circ = $('nj-rs-circ'), dia = $('nj-rs-dia'), us = $('nj-rs-us'),
      au = $('nj-rs-au'), eu = $('nj-rs-eu'),
      hint = $('nj-rs-hint'), reset = $('nj-rs-reset');
  if (!circ || !au) return;
  var opt = document.createElement('option');
  opt.value = ''; opt.textContent = 'Choose...';
  au.appendChild(opt);
  for (var i=0; i<sizes.length; i++){
    var o = document.createElement('option');
    o.value = sizes[i].mm;
    o.textContent = sizes[i].au + ' (AU) · ' + sizes[i].us + ' (US)';
    o.setAttribute('data-au', sizes[i].au);
    au.appendChild(o);
  }
  var updating = false;
  function update(src, val){
    if (updating) return;
    updating = true;
    var mm = NaN;
    if (src==='circ') mm = parseFloat(val);
    else if (src==='dia') mm = parseFloat(val) * Math.PI;
    else if (src==='us') mm = usToMm(parseFloat(val));
    else if (src==='au') mm = parseFloat(val);
    else if (src==='eu') mm = parseFloat(val);
    if (!isFinite(mm) || mm < 35 || mm > 85){
      if (src!=='circ') circ.value = '';
      if (src!=='dia') dia.value = '';
      if (src!=='us') us.value = '';
      if (src!=='au') au.value = '';
      if (src!=='eu') eu.value = '';
      hint.innerHTML = '';
      updating = false;
      return;
    }
    if (src!=='circ') circ.value = mm.toFixed(1);
    if (src!=='dia') dia.value = (mm/Math.PI).toFixed(2);
    if (src!=='us') us.value = fmtUs(mmToUs(mm));
    if (src!=='eu') eu.value = mm.toFixed(1);
    var c = closest(mm);
    if (src!=='au'){
      var found = false;
      for (var j=0; j<au.options.length; j++){
        if (au.options[j].getAttribute('data-au') === c.au){
          au.selectedIndex = j; found = true; break;
        }
      }
      if (!found) au.value = '';
    }
    var off = Math.abs(c.mm - mm);
    var msg = 'Closest stocked size: <strong>' + c.au + ' (AU) · ' + c.us + ' (US)</strong> at ' + c.mm.toFixed(1) + ' mm';
    if (off > 0.7) msg += " — you're between two sizes; we can resize most rings by one AU letter either way.";
    hint.innerHTML = msg;
    updating = false;
  }
  circ.addEventListener('input', function(e){ update('circ', e.target.value); });
  dia.addEventListener('input', function(e){ update('dia', e.target.value); });
  us.addEventListener('input', function(e){ update('us', e.target.value); });
  au.addEventListener('change', function(e){ update('au', e.target.value); });
  eu.addEventListener('input', function(e){ update('eu', e.target.value); });
  reset.addEventListener('click', function(){
    circ.value = dia.value = us.value = eu.value = '';
    au.value = '';
    hint.innerHTML = '';
  });
})();
